export default __webpack_public_path__ + "static/media/limb_mobile.4f3d7858.svg";